import { render } from "./MedicoList.vue?vue&type=template&id=77eaa3ab&scoped=true"
import script from "./MedicoList.vue?vue&type=script&lang=js"
export * from "./MedicoList.vue?vue&type=script&lang=js"

import "./MedicoList.vue?vue&type=style&index=0&id=77eaa3ab&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77eaa3ab"]])

export default __exports__